// page route for equipment

import React from "react";

import { Route, Routes } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import useRoleCheck from "utilities/hooks/roleCheck";

//import dependent pages
import EquipmentLayout from "./layout";
import Equipment from "./components/Equipment";
import Inventory from "./components/Inventory";
import Requests from "./components/Requests";
import Training from "./components/Training";
import RequestDetails from "./components/Requests/components/RequestDetails";
import Calibrations from "./components/Calibrations";

function EquipmentRouter() {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useRoleCheck();

  return (
    <Routes>
      <Route path="" element={<EquipmentLayout />}>
        <Route path="/" element={<Equipment />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/requests" element={<Requests />}>
          <Route path=":request_id" element={<RequestDetails />} />
        </Route>
        <Route path="/calibrations" element={<Calibrations />} />
        {/* <Route path="/training" element={<Training />} /> */}
      </Route>
    </Routes>
  );
}

export default EquipmentRouter;
